import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import AttachmentUploader, { FILE_TYPE } from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import { Feature } from '@tencent/workbench';
import { config } from './config';


@Feature()
export class InsertAudioFeature extends BaseToolbarFeature {
    public id = config.id;
    public config = config;

    public constructor() {
        super();
    }

    public insertAudio(name: string, clickFrom?: string) {
        AttachmentUploader.getInstance().upload({ acceptFileType: { audio: FILE_TYPE.audio } });
        try {
            this.twdReport(name, clickFrom);
        } catch (e) {
            window.log.error('upload audio twd error');
        }
    }
}
